import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FaceScan = lazyWithPreload(() => import('./FaceScan'))
